import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import OurServices from "./pages/OurServices";
import Clients from "./pages/Clients";
import OurTeam from "./pages/OurTeam";
import ScrollToTopButton from "./components/ScrollToTopButton";
import SideBadge from "./components/SideBadge";
import MaharashtraClientsPage from "./pages/MaharashtraClientsPage";
import DamanClientsPage from "./pages/DamanClientsPage";
import GujaratClientsPage from "./pages/GujaratClientsPage";
import AndhraPradeshClientsPage from "./pages/AndhraPradeshClientsPage";
import TelanganaClientsPage from "./pages/TelanganaClientsPage";
import Journey from "./pages/Journey";
import NotFound from "./components/NotFound";
import Resources from "./components/Resources";

function App() {
 
  return (
    <>
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/services" element={<OurServices />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/maharashtra" element={<MaharashtraClientsPage />} />
            <Route path="/clients/daman" element={<DamanClientsPage />} />
            <Route path="/clients/gujarat" element={<GujaratClientsPage />} />
            <Route path="/clients/andhra-pradesh" element={<AndhraPradeshClientsPage />} />
            <Route path="/clients/telangana" element={<TelanganaClientsPage />} />
            <Route path="/ourteam" element={<OurTeam />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/journey" element={<Journey />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>

          <ScrollToTopButton />
          <SideBadge />
          <Footer />
        </Router>    
        <SpeedInsights />
    
    </>
  );
}

export default App;
